import { combineReducers } from 'redux'
import { createAction } from 'redux-actions'

import flights, { selectors as flightsSelectors } from './flights'
import games, { selectors as gamesSelectors } from './games'
import matches, { selectors as matchesSelectors } from './matches'
import shots, { selectors as shotsSelectors } from './shots'

export const selectors = {
  getFlights: s => flightsSelectors.getFlights(s.flights),
  getGames: s => gamesSelectors.getGames(s),
  getMatches: s => matchesSelectors.getMatches(s),
  getShots: s => shotsSelectors.getShots(s.shots),

  getSyncStartedAt: matchesSelectors.getSyncStartedAt,
  getSyncFinishedAt: matchesSelectors.getSyncFinishedAt,
  getSyncSucceededAt: matchesSelectors.getSyncSucceededAt,
  getSyncFailedAt: matchesSelectors.getSyncFailedAt
}

export const types = {
  CREATE: 'matches/CREATE',
  SYNC: 'matches/SYNC',
  CLEAR: 'matches/CLEAR'
}

export const actions = {
  create: createAction(types.CREATE),
  sync: createAction(types.SYNC),
  clear: createAction(types.CLEAR)
}

export default combineReducers({
  flights,
  games,
  matches,
  shots
})
